// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ni5d","content":"styles_content__3iywh"};